import Code from './code.vue';
export default Code;


// WEBPACK FOOTER //
// ./src/components/code/index.js